// src/components/ResetPassword.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  Alert,
  AlertIcon,
  Divider,
} from '@chakra-ui/react';
import { useSectionBgGradient } from '../style/palette';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetCode = searchParams.get('code');

  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (password !== passwordConfirmation) {
      setErrorMessage('Le password non corrispondono');
      return;
    }
    if (!resetCode) {
      setErrorMessage("Codice di reset non trovato nell'URL");
      return;
    }

    try {
      const response = await axios.post('/api/reset-password', {
        code: resetCode,
        password,
        passwordConfirmation,
      });

      setSuccessMessage(response.data.message);
      setPassword('');
      setPasswordConfirmation('');
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || 'Si è verificato un errore'
      );
    }
  };

  useEffect(() => {
    if (successMessage) {
      navigate(`/account`, { replace: true });
    }
  }, [successMessage]);

  const bgGradient = useSectionBgGradient();

  return (
    <Container
      maxW="lg"
      mt={12}
      p={8}
      borderRadius="md"
      boxShadow="lg"
      bgGradient={bgGradient}
    >
      <Heading mb={4} fontSize="32px">
        Ripristina la Password
      </Heading>
      <Divider mb={4} />
      {successMessage && (
        <Alert status="success" mb={4} mt={6}>
          <AlertIcon />
          {successMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert status="error" mb={4}>
          <AlertIcon />
          {errorMessage}
        </Alert>
      )}
      {!successMessage && (
        <form onSubmit={handleSubmit}>
          <FormControl mb={4}>
            <FormLabel>Nuova Password</FormLabel>
            <Input
              type="password"
              placeholder="Nuova password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Conferma Nuova Password</FormLabel>
            <Input
              type="password"
              placeholder="Conferma nuova password"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              required
            />
          </FormControl>

          <Button type="submit" colorScheme="blue">
            Aggiorna Password
          </Button>
        </form>
      )}
    </Container>
  );
};

export default ResetPassword;
